var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import React, { PureComponent } from "react";
import { Label2 } from "@irati/ui/src/Labels";
import { H2, H3 } from "@irati/ui/src/Headings";
import { FormattedMessage, FormattedCurrency } from "@irati/utils/lang";
import { LabelContainer, ActivityBlockItem, StyledTooltip, ValueContainer } from "../styled/styled";
var DataItem = /** @class */ (function (_super) {
    __extends(DataItem, _super);
    function DataItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DataItem.prototype.render = function () {
        var _a = this.props, dataItem = _a.dataItem, isPercentage = _a.isPercentage, toolTipText = _a.toolTipText, currency = _a.currency, label = _a.label, bold = _a.bold, addLeftPadding = _a.addLeftPadding, isCents = _a.isCents, large = _a.large;
        var HeaderComp = large ? H2 : H3;
        return (React.createElement(ActivityBlockItem, { addLeftPadding: addLeftPadding },
            React.createElement(LabelContainer, null,
                React.createElement(Label2, { uppercase: true, bold: true },
                    React.createElement(FormattedMessage, { id: label })),
                React.createElement(StyledTooltip, { tooltipChildren: "testing", placement: "top" },
                    React.createElement(FormattedMessage, { id: toolTipText }))),
            React.createElement(ValueContainer, null, currency ? (React.createElement(HeaderComp, { bold: bold },
                React.createElement(FormattedCurrency, { currency: currency, value: dataItem, isCents: isCents }))) : (React.createElement(HeaderComp, { uppercase: true, bold: bold },
                dataItem,
                isPercentage && "%")))));
    };
    DataItem.defaultProps = {
        isPercentage: false,
        toolTipText: null,
        label: null,
        isCents: true,
        large: false
    };
    return DataItem;
}(PureComponent));
export default DataItem;
